import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  timer = null;

  static values = {
    id: String,
    url: String,
    debug_url: String
  }

  connect() {
    console.log("payment_intent_controller", this.element);

    this.checkPaymentIntent();
    this.timer = setInterval(this.tick.bind(this), 3000);
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  tick(e)  {
    this.checkPaymentIntent();
  }

  checkPaymentIntent() {
    fetch(this.urlValue)
      .then( response => response.json())
      .then( (response) => {
        console.log(response);
        if(response.complete) {
          clearInterval(this.timer);
          this.timer = null;
          console.log("complete")
          window.location = response.redirect_url
        }
      });
  }
}
